export const middleEllipsisedText = (value, limit) => {
    let ellipsisedName = value;
    if (value.length > limit) {
        ellipsisedName = value.substr(0, limit) + "..." + value.substring(value.length - limit - 1);
    }
    return ellipsisedName;

};

export const capitalizeFirstLetter = function (string) {
    if (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return "";
};
